import { render, staticRenderFns } from "./RootCauseAnalysisHistoryReportCard.vue?vue&type=template&id=01159dd7&scoped=true&"
import script from "./RootCauseAnalysisHistoryReportCard.vue?vue&type=script&lang=js&"
export * from "./RootCauseAnalysisHistoryReportCard.vue?vue&type=script&lang=js&"
import style0 from "./RootCauseAnalysisHistoryReportCard.vue?vue&type=style&index=0&id=01159dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01159dd7",
  null
  
)

export default component.exports